import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { scrollToId } from "@/lib/api";
import { Wordmark } from "@/components/Logo";

const LINKS = ["services"];

export const LangSwitch = () => {
  const { lang, setLang } = useLang();
  return (
    <div className="flex items-center rounded-full border border-white/15 p-0.5 bg-white/5" data-testid="lang-switch">
      {["fr", "en", "pt"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          onClick={() => setLang(l)}
          className="relative px-2.5 py-1 font-mono text-[11px] uppercase tracking-wider"
        >
          {lang === l && (
            <motion.span layoutId="lang-pill" className="absolute inset-0 rounded-full bg-[#2DD4BF]" transition={{ type: "spring", stiffness: 400, damping: 32 }} />
          )}
          <span className={`relative transition-colors ${lang === l ? "text-[#0B1F3A]" : "text-slate-300 hover:text-white"}`}>{l}</span>
        </button>
      ))}
    </div>
  );
};

export const Nav = () => {
  const { t } = useLang();
  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 inset-x-0 z-50 border-b border-white/10 bg-[#0B1F3A]/90 backdrop-blur-xl"
      data-testid="main-nav"
    >
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10 h-16 flex items-center justify-between gap-4">
        <button onClick={() => window.__lenis?.scrollTo(0)} data-testid="nav-logo" aria-label="bsys">
          <Wordmark />
        </button>
        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((k) => (
            <button key={k} data-testid={`nav-${k}`} onClick={() => scrollToId(k)} className="group relative text-sm text-slate-300 hover:text-white transition-colors">
              {t.nav[k]}
              <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-0 bg-[#2DD4BF] transition-transform duration-300 group-hover:scale-x-100" />
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-2 sm:gap-3">
          <LangSwitch />
          <Link to="/admin" data-testid="nav-admin" aria-label={t.nav.admin} className="hidden sm:grid place-items-center w-8 h-8 rounded-full border border-white/15 text-slate-300 hover:text-[#2DD4BF] hover:border-[#2DD4BF] transition-colors">
            <Lock size={13} />
          </Link>
          <button
            data-testid="nav-join-btn"
            onClick={() => scrollToId("join")}
            className="rounded-full bg-[#2DD4BF] text-[#0B1F3A] px-4 py-2 text-sm font-semibold hover:bg-white transition-colors"
          >
            {t.nav.join}
          </button>
        </div>
      </div>
    </motion.header>
  );
};
